import { b2bUrl } from "util/url/static-urls";

export const STATIC_PAGES_OLD = [
  "/free-shipping",
  "/careers-in-automotive-industry",
  "/careers",
  "/about-partsavatar-canada",
  "/about-us",
  "/team",
  "/returns",
  "/rapid-delivery",
  "/auto-parts-free-shipping-canada",
  "/car-parts-news-in-canada",
  "/predictive-viewall",
  "/covid19-message",
  "/financing",
  "/tire-calculator",
  "/warranty-on-auto-parts",
  "/wheels-tires",
  "/contact-us-for-car-parts",
  "/questions-about-autoparts",
  "/in-store-pickup",
  "/newsletter-sign-up",
  "/all-parts",
  b2bUrl,
];

export const STATIC_PAGES = [
  ...STATIC_PAGES_OLD,
  "/car-parts",
  "/aftermarket-car-parts",
  "/oem-parts",
  "/auto-parts",
  "/napa-auto-parts",
  "/partsource",
  "/rockauto",
  "/japan-parts",
  "/pickup-truck-parts",
  "/parts-for-trucks",
  "/auto-parts-montreal",
  "/automotive-parts",
  "/car-parts-near-me",
  "/auto-parts-near-me",
  "/auto-parts-toronto",
  "/auto-shop",
  "/german-parts",
  "/auto-repair",
  "/auto-parts-near-me-in-toronto",
  "/auto-parts-near-me-in-vancouver",
  "/auto-parts-near-me-in-hamilton",
  "/auto-parts-near-me-in-brampton",
  "/auto-parts-near-me-in-winnipeg",
  "/auto-parts-near-me-in-mississauga",
  "/auto-parts-near-me-in-edmonton",
  "/auto-parts-near-me-in-ottawa",
  "/auto-parts-near-me-in-montreal",
  "/auto-parts-near-me-in-calgary",
  "/the-wrench-monkey",
  "/summit-racing",
  "/tdot-performance",
  "/parts-engine",
  "/amazon-auto-parts",
  "/Bernardi-parts",
  "/canadian-tire-auto-parts",
  "/carid",
  "/ebay-auto-parts",
  "/ford-parts-giant",
  "/german-parts-ca",
  "/honda-automotive-parts",
  "/kanata-honda",
  "/toronto-honda",
  "/sherwood-ford",
  "/auto-parts-way",
  "/bd-diesel",
  "/rivercity-ford",
  "/tasca-parts",
  "/nissan-parts-canada",
  "/kia-parts-online",
  "/hansen-ford",
  "/gateway-toyota",
  "/donvalley-north-toyota",
  "/dodge-parts-canada",
  "/dixie-ford",
  "/dams-ford",
  "/canada-mopar-parts",
  "/brantford-toyota",
  "/benton-fry-ford",
  "/top-toyota-parts",
  "/toyota-parts-direct",
  "/mopar-dodge",
  "/royal-oak-nissan",
  "/kia-parts-now",
  "/kia-parts-superstore",
  "/mopar-parts-canada",
  "/nissan-parts-deal",
  "/toyota-parts-deal",
  "/northland-kia",
  "/the-parts-place",
  "/scarboro-subaru",
  "/subaru-online-parts",
  "/subaru-parts-deal",
  "/subaru-parts-canada",
  "/subie-depot",
  "/subimods",
  "/mitsubishi-parts-canada",
  "/mitsubishi-parts-warehouse",
  "/northside-mitsubishi",
  "/auto-hauz-az",
  "/fcp-euro",
  "/mb-parts",
  "/mercedes-oem-parts",
  "/mazda-parts-canada",
  "/mazda-parts-advantage",
  "/mazda-shop",
  "/palladino-mazda",
  "/scarboro-mazda",
  "/gta-jeeps",
  "/just-jeeps",
  "/hyundai-parts-deal",
  "/hyundai-parts-online",
  "/gm-parts-direct",
  "/kipp-scott",
  "/my-gm-parts",
  "/get-bmw-parts",
  "/parts-avatar-alternatives",
  "/bmw-toronto",
  "/chevrolet-parts-canada",
  "/gm-parts-giant",
  "/gmc-parts-canada",
  "/hyundai-parts-pro",
  "/nsor",
  "/quadratec",
  "/raven-truck",
  "/real-oem",
  "/rugged-ridge",
  "/jack-carter-gm-parts",
  "/carid-rockauto-tdot-general",
  "/eastgate-toyotadirect-make-specific",
  "/apparel",
  "/email-preference",
  "/proudly-canadian",
  "/autoshack",
  "/parts-hub",
  "/parts-geek",
  "/parts-king",
  "/autozone-store",
  "/advance-auto",
  "/autovalue",
  "/lordco",
  "/oreilly",
  "/vinnistore",
  "/dealerships",
  "/rewards",
];

export const PAGE_WITH_HP_UI = [
  "car-parts",
  "aftermarket-car-parts",
  "oem-parts",
  "auto-parts",
  "japan-parts",
  "pickup-truck-parts",
  "parts-for-trucks",
  "auto-parts-montreal",
  "automotive-parts",
  "car-parts-near-me",
  "auto-parts-near-me",
  "auto-parts-toronto",
  "auto-shop",
  "german-parts",
  "auto-repair",
  "auto-parts-near-me-in-toronto",
  "auto-parts-near-me-in-vancouver",
  "auto-parts-near-me-in-hamilton",
  "auto-parts-near-me-in-brampton",
  "auto-parts-near-me-in-winnipeg",
  "auto-parts-near-me-in-mississauga",
  "auto-parts-near-me-in-edmonton",
  "auto-parts-near-me-in-ottawa",
  "auto-parts-near-me-in-montreal",
  "auto-parts-near-me-in-calgary",
];

export const COMPETITOR_PAGES = [
  "napa-auto-parts",
  "partsource",
  "rockauto",
  "the-wrench-monkey",
  "tdot-performance",
  "summit-racing",
  "parts-engine",
  "amazon-auto-parts",
  "Bernardi-parts",
  "canadian-tire-auto-parts",
  "carid",
  "ebay-auto-parts",
  "ford-parts-giant",
  "german-parts-ca",
  "honda-automotive-parts",
  "kanata-honda",
  "toronto-honda",
  "sherwood-ford",
  "auto-parts-way",
  "bd-diesel",
  "rivercity-ford",
  "tasca-parts",
  "nissan-parts-canada",
  "kia-parts-online",
  "hansen-ford",
  "gateway-toyota",
  "donvalley-north-toyota",
  "dodge-parts-canada",
  "dixie-ford",
  "dams-ford",
  "canada-mopar-parts",
  "brantford-toyota",
  "benton-fry-ford",
  "top-toyota-parts",
  "toyota-parts-direct",
  "mopar-dodge",
  "royal-oak-nissan",
  "kia-parts-now",
  "kia-parts-superstore",
  "mopar-parts-canada",
  "nissan-parts-deal",
  "toyota-parts-deal",
  "northland-kia",
  "auto-hauz-az",
  "fcp-euro",
  "get-bmw-parts",
  "gm-parts-direct",
  "gta-jeeps",
  "hyundai-parts-deal",
  "hyundai-parts-online",
  "just-jeeps",
  "kipp-scott",
  "mazda-parts-advantage",
  "mazda-parts-canada",
  "mazda-shop",
  "mb-parts",
  "mercedes-oem-parts",
  "mitsubishi-parts-warehouse",
  "mitsubishi-parts-canada",
  "my-gm-parts",
  "northside-mitsubishi",
  "palladino-mazda",
  "scarboro-mazda",
  "scarboro-subaru",
  "subaru-online-parts",
  "subaru-parts-canada",
  "subie-depot",
  "subimods",
  "the-parts-place",
  "subaru-parts-deal",
  "bmw-toronto",
  "chevrolet-parts-canada",
  "gm-parts-giant",
  "gmc-parts-canada",
  "hyundai-parts-pro",
  "nsor",
  "quadratec",
  "raven-truck",
  "real-oem",
  "rugged-ridge",
  "jack-carter-gm-parts",
  "autoshack",
  "parts-hub",
  "parts-geek",
  "parts-king",
  "autozone-store",
  "advance-auto",
  "autovalue",
  "lordco",
  "oreilly",
  "dealerships",
  "vinnistore",
];

export const COMPARE_COMPETITOR_PAGES = [
  "parts-avatar-alternatives",
  "carid-rockauto-tdot-general",
  "eastgate-toyotadirect-make-specific",
];

// add entry of url here, for whoch you wants to make get-page-details apis call
export const PAGE_WITH_GET_PAGE_DETAILS = [
  "free-shipping",
  "aftermarket-parts-return-policy",
  "auto-parts-free-shipping-canada",
  "returns",
  "rapid-delivery",
  "in-store-pickup",
  "contact-us-for-car-parts",
  "about-partsavatar-canada",
  "questions-about-autoparts",
  "warranty-on-auto-parts",
  "gp",
  "financing",
  "rewards",
];

// usually these page give 502 error on SSR, as json form CMS is very big.
export const CMS_PAGE_CSR_ONLY = [
  "rockauto",
  "check-engine-light-scan-read-all-obd-2-trouble-codes-p0-powertrain-p1-p2-diagnose-repair-fix-engine-error",
  "cardone-industries-auto-parts-catalogue-find-cardone-industries-part-number",
  "dorman-oe-solutions-auto-parts-catalogue-find-dorman-oe-solutions-part-number",
];
